import { wrapUrls } from 'jsx/utils/urlWrapper';
import { SUPPORT_URLS } from 'jsx/constants/urls';

const API_URLS = {
  dobEligibility: 'api.auth.eligibility.dob',
  emailEligibility: 'api.auth.eligibility.email',
  login: 'api.auth.login',
  register: 'api.auth.register',
  registerOtc: 'api.auth.register.store',
  resetPassword: 'api.auth.resetPassword',
  sendPasswordReset: 'api.auth.forgotPassword',
  sendMagicLink: 'login.magic',
  useMagicLink: 'login.magic.callback',
  verifyEmail: 'email.verify',
} as const;

const REGISTRATION_ELIGIBILITY_API = {
  show: 'api.eligibility.registration.show',
  post: 'api.eligibility.registration.post',
  delete: 'api.eligibility.registration.delete',
} as const;

export default {
  login: '/auth/login',
  loginEmail: '/auth/login/email',
  loginEmailSent: '/auth/login/email/sent',
  loginExpired: '/auth/login/:method/expired',
  welcome: '/auth/welcome',
  dateOfBirth: '/auth/welcome/dateofbirth',
  register: '/auth/welcome/register',
  registerOtc: '/auth/register-otc',
  notEligible: '/auth/welcome/availability-notice',
  emailSaved: '/auth/welcome/email-saved',
  deletingOldAccount: '/auth/welcome/deleting-old-account',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',
  get20: '/get20',

  // other apps
  dashboard: '/dashboard/home',
  signup: '/signup/eligibility/state',
  ...SUPPORT_URLS,

  api: {
    ...wrapUrls(API_URLS),
    registrationEligibility: wrapUrls(REGISTRATION_ELIGIBILITY_API),
  },
};
